// @flow

import React, { useState, useEffect, type Node } from 'react';
import styled from 'styled-components';

import { toDataURL as toQRCodeDataURL } from 'qrcode';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Link } from '../../../../atoms';
import { getCashfreeUpiQRCode } from '@tectonics/prs/incoming-payment/get-cashfree-upi-qr-code';

export function TicketCode(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const qrCodeValue = getCashfreeUpiQRCode(incomingPayment);
  const [qrCodeData, setQrCodeData] = useState();

  useEffect(() => {
    (async () => {
      const data = await toQRCodeDataURL(qrCodeValue, { width: '136px', height: '136px' });
      setQrCodeData(data);
    })();
  }, [qrCodeData]);

  return (
    <Root>
      <Term>QR Code</Term>
      <Caption> Scan the following QR code in your bank app to complete your payment in just a few seconds</Caption>
      <div style={{ margin: '20px auto' }}>
        <img src={ getCashfreeUpiQRCode(incomingPayment) } alt="qrcode" style={{ border: '2px solid rgba(0,0,0,.1)', height: '256px' }} />
      </div>
      <Link href={ getCashfreeUpiQRCode(incomingPayment) } download="qrcode.png"><strong>Downlaod QR Code Image </strong></Link>
    </Root>
  );
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;

const Caption = styled.p`
  font-size: 0.9em;
  font-family: ${props => props.theme.fontFamily.sansSerif};
  margin: 0.5em 0;
`;
